import { routes } from 'core/routing';
import SitesTable from 'features/all-projects/SitesTable';
import UnknownSitesTable from 'features/all-projects/UnknownSitesTable';
import Link from 'shared/components/Link';
import SpacingLayout from 'shared/components/SpacingLayout';
import styles from 'theme/features/all-projects/all-projects.module.scss';

const ProjectsList = ({ isArchived, isConfidential, isFinal }) => (
  <SpacingLayout className={styles.wrapper}>
    <div className={styles.heading}>
      <h1>
        <strong>{isArchived ? 'Archived' : 'All'} Projects</strong>
      </h1>
      {isArchived ? (
        <Link href={routes.allProjects()}>View All Projects</Link>
      ) : (
        <Link href={routes.archivedProjects()}>View Archive</Link>
      )}
    </div>
    <SitesTable isArchived={isArchived} isConfidential={isConfidential} isFinal={isFinal} />
    <UnknownSitesTable isArchived={isArchived} isConfidential={isConfidential} isFinal={isFinal} />
  </SpacingLayout>
);

export default ProjectsList;
